import { ITranslationEntry } from '../lang';

export const KK: ITranslationEntry = {
  translations: {
    notifications: 'Хабарландырулар',
    markAllAsRead: 'барлығын оқылған деп белгілеңіз',
    poweredBy: 'задвижвани от',
    settings: 'көмегімен',
  },
  lang: 'kk',
};
